<script setup lang="ts">
import { type Image } from '@sanity/types';

const props = defineProps<{
  image?: Image;
  parallax?: boolean;
}>();
</script>

<template>
  <BaseImage v-if="image && !props.parallax" :image="image" class="c-image" />
  <BaseParallaxImage v-if="image && props.parallax" :image="image" class="c-image" />
</template>

<style scoped>
.c-image {
  width: 100%;
  height: 360px;
  object-fit: cover;

  @screen tablet-wide {
    height: 640px;
  }
}
</style>
